/**
 * Site-wide wishlist: stores product handles in localStorage and keeps every
 * wishlist heart button + the header count badge in sync across pages.
 */
(function () {
  var STORAGE_KEY = 'vd_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.unshift(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    document.dispatchEvent(new CustomEvent('vd:wishlist:change', { detail: { list: list } }));
    return list.indexOf(handle) !== -1;
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('has-items', count > 0);
    });
  }

  function syncButtonState(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    btn.classList.toggle('is-active', isWishlisted(handle));
  }

  function wireButton(btn) {
    if (btn.dataset.wishlistWired === 'true') {
      syncButtonState(btn);
      return;
    }
    btn.dataset.wishlistWired = 'true';
    syncButtonState(btn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-wishlist-handle');
      if (!handle) return;
      toggle(handle);
    });
  }

  function refresh() {
    document.querySelectorAll('[data-wishlist-handle]').forEach(wireButton);
    updateCountBadges();
  }

  document.addEventListener('vd:wishlist:change', function () {
    document.querySelectorAll('[data-wishlist-handle]').forEach(syncButtonState);
    updateCountBadges();
  });

  document.addEventListener('DOMContentLoaded', refresh);

  // Back/forward navigations can restore a page from the browser's bfcache
  // without re-running scripts or firing DOMContentLoaded, which is what
  // left the badge showing whatever count happened to be in the DOM at the
  // time of caching. Re-sync from localStorage every time the page is shown.
  window.addEventListener('pageshow', refresh);

  window.VDWishlist = {
    get: getWishlist,
    has: isWishlisted,
    toggle: toggle,
    refresh: refresh
  };
})();
